import React, { useRef} from "react";
// import MainLayout from './Layouts/MainLayout';
import Header from "./Header/Header";
import Home from "./Components/Home";
// import Products from "./Pages/Products";
import About from "./Components/About";
import BussinceExcellence from "./Components/BussinceExcellence";
import Testimonials from "./Components/Testimonials";
import Footer from "./Footer/Footer";

import ContactUs from "./Components/ContactUs";
// import Gallary from "./Gallary";
import Infraart from "./Components/Infraart";
import Productsrange from "./Pages/Productsrange";
import Popicon from "./Components/Popicon";
// import Navtop from "./Topnavbar/Navtop";
// import Demobar from "./Demonavbar/Demobar";
import Connectwus from "./Components/Connectwus";
import TagLine from "./TagLine/TagLine";

export default function MianLayout() {
  const home = useRef(null);
  const about = useRef(null);
  const products = useRef(null);
  const bussiness = useRef(null);
  const test = useRef(null);
  return (
    <div>
      <section className="" id="header">
        <Header />
        <Popicon />
      </section>
      <div ref={home} id="home">
        <Home />
      </div>
      <div ref={about} id="about">
        <About />
      </div>
      <div ref={products} id="products">
        <Productsrange />
      </div>
      <div>
        <Infraart />
      </div>

      <div ref={bussiness} id="bussinessExcellence">
        <BussinceExcellence />
      </div>
      <TagLine />
      <section ref={test} id="services">
        <Testimonials />
      </section>
      <Connectwus />
      <ContactUs />
      <Footer />
    </div>
  );
}
